import './content.scss';
import {renderMarkdown} from './markdown';

export type TextAlign = 'left' | 'center' | 'right';

/** What TextV2.php puts into data-db-options, already in the viewer's locale. */
export interface TextProps {
    content: string;
    align: TextAlign;
    card: boolean;
    title: string | null;
    minHeight: number | null;
}

export const SECTION_TONES = ['default', 'primary', 'secondary', 'light', 'dark'] as const;
export type SectionTone = typeof SECTION_TONES[number];

/** Same pattern as section.v2.schema.json and SectionV2.php */
const HEX_COLOR = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;

const ALIGN_CLASSES: Record<TextAlign, string> = {left: 'text-start', center: 'text-center', right: 'text-end'};

export function sectionTone(tone: unknown): SectionTone {
    return SECTION_TONES.find(known => known === tone) ?? 'default';
}

export function hexColor(value: unknown): string | null {
    return typeof value === 'string' && HEX_COLOR.test(value) ? value : null;
}

function element(tag: string, className: string, children: Node[] = []): HTMLElement {
    const el = document.createElement(tag);
    el.className = className;
    el.append(...children);
    return el;
}

export function renderText(target: HTMLElement, props: TextProps): void {
    const body = element('div', 'db-text-v2__body ' + (ALIGN_CLASSES[props.align] ?? ALIGN_CLASSES.left));
    body.innerHTML = renderMarkdown(props.content);

    const title = props.title ? element('h3', props.card ? 'card-title' : 'db-text-v2__title') : null;
    title?.append(props.title!);

    const root = props.card
        ? element('div', 'card db-text-v2', [
            ...(title ? [element('div', 'card-header', [title])] : []),
            element('div', 'card-body', [body]),
        ])
        : element('div', 'db-text-v2 db-text-v2--plain', title ? [title, body] : [body]);

    if (typeof props.minHeight === 'number' && props.minHeight > 0) {
        root.style.minHeight = props.minHeight + 'px';
    }
    target.replaceChildren(root);
}
